import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    name: 'user',
    initialState: {
        name: '',
        hash: '',
        isLogged: false,
        marcas: [],
        grupos: [],
        unidMedidas: [],
        tributacao: [],
        modeDark: 'light',
        produtos: [],
        fornecedores: [],
        transportadora: [],
        clientes: [],
        formPagam: [],
        subGrupo: [],
        naturezaOperacao: [],
        empresas: [],
        serie: [],
        grupoDespesa: [],
        sgrupoDespesa: [],
        contaApagar: [],
        contaApagarExcluidas: [],
        clientesExcluidos: [],

        // colunas da grid produtos
        checkDesc: '',
        checkCodBarra: '',
        checkReferencia: '',
        checkGrupo: '',
        checkSgrupo: '',
        checkMarca: '',
        checkunid: '',
        checkPCusto: '',
        checkPVenda: '',
        checkPeso: '',
        checkgTributacao: '',
        checkEstoque: '',
        checkEstoqueFisico: '',
        checkNcm: '',
        checkCest: '',
        checkTipo: '',
        checkAtivo: '',
        checkEstoqueMinimo: '',
        checkDt_cadastro: '',
        checkOrigem: '',

        // colunas da grid clientes
        checkPessoaCli: '',
        checkDocCli: '',
        checkRazaoNomeCli: '',
        checkFantasiaCli: '',
        checkDt_cadastroCli: '',
        checkIeRgCli: '',
        checkAtivoCli: '',
        checkObsCli: '',
        checkCepCli: '',
        checkEnderecoCli: '',
        checkBairroCli: '',
        checkNumeroCli: '',
        checkComplCli: '',
        checkEstadoCli: '',
        checkCidadeCli: '',

        // colunas da grid forma pagamento
        checkDescPag: '',
        checkAcresPag: '',
        checkDesconPag: '',
        checkOrdemPag: '',
        checkDt_cadastroPag: '',
        checkVlMinPag: '',
        checkTipoPag: '',

        // colunas da grid natureza de operação
        checkDescNat: '',
        checkCfop_entradaNat: '',
        checkCfop_saidaNat: '',
        checkCfop_internoNat: '',
        checkCfop_externoNat: '',
        checkCst_dentroNat: '',
        checkCst_foraNat: '',
        checkDt_cadastroNat: '',

        // colunas da grid empresas
        checkRazaoEmp: '',
        checkFantasiaEmp: '',
        checkRuaEmp: '',
        checkBairroEmp: '',
        checkNumeroEmp: '',
        checkCepEmp: '',
        checkComplEmp: '',
        checkCidadeEmp: '',
        checkCnpjEmp: '',
        checkIeEmp: '',
        checkCnaeEmp: '',
        checkRegTribEmp: '',
        checkAtivoEmp: '',
        checkUfEmp: '',
        checkDt_cadastroEmp: '',

        // colunas da grid Tributação
        checkDescTrib: '',
        checkPICMSTrib: '',
        checkPPISTrib: '',
        checkPCOFINSTrib: '',
        checkCstPisCofinsTrib: '',
        checkCfopSDentroTrib: '',
        checkCfopSForaTrib: '',
        checkCfopEdentroTrib: '',
        checkCfopEforaTrib: '',
        checkCstICMSDentroTrib: '',
        checkCstICMSForaTrib: '',
        checkDt_cadastroTrib: '',

        // colunas da grid Transportadora
        checkRazaoTransp: '',
        checkFantTransp: '',
        checkEndTransp: '',
        checkBairroTransp: '',
        checkNumTransp: '',
        checkCepTransp: '',
        checkCidadeTransp: '',
        checkComplTransp: '',
        checkIeRgTransp: '',
        checkObsTransp: '',
        checkTipoTransp: '',
        checkDocTransp: '',
        checkAtivoTransp: '',
        checkUfTransp: '',
        checkDt_cadastroTransp: '',

        // colunas da grid Fornecedor
        checkEnderecoForn: '',
        checkBairroForn: '',
        checkCepForn: '',
        checkDocForn: '',
        checkComplementoForn: '',
        checkNomeRazaoForn: '',
        checkFantasiaForn: '',
        checkNumeroForn: '',
        checkObservacaoForn: '',
        checkTipo_pessoaForn: '',
        checkUfForn: '',
        checkIe_rgForn: '',
        checkCidadeForn: '',
        checkAtivoForn: '',
        checkDt_cadastroForn: '',

    },
    reducers: {
        changeUser(state, { payload }) {
            return { ...state, isLogged: true, name: payload }
        },
        changeHash(state, { payload }) {
            return { ...state, hash: payload }
        },
        changeName(state, { payload }) {
            return { ...state, name: payload };
        },
        changeMarcas(state, { payload }) {
            return { ...state, marcas: payload };
        },
        changeGrupos(state, { payload }) {
            return { ...state, grupos: payload };
        },
        changeUnidMedidas(state, { payload }) {
            return { ...state, unidMedidas: payload };
        },
        changeTributacao(state, { payload }) {
            return { ...state, tributacao: payload };
        },
        changeDark(state, { payload }) {
            return { ...state, modeDark: payload };
        },
        changeProdutos(state, { payload }) {
            return { ...state, produtos: payload };
        },
        changeFornecedores(state, { payload }) {
            return { ...state, fornecedores: payload };
        },
        changeTransportadora(state, { payload }) {
            return { ...state, transportadora: payload };
        },
        changeClientes(state, { payload }) {
            return { ...state, clientes: payload };
        },
        changeFormaPagam(state, { payload }) {
            return { ...state, formPagam: payload };
        },
        changeSubGrupo(state, { payload }) {
            return { ...state, subGrupo: payload };
        },
        changeNaturezaOperacao(state, { payload }) {
            return { ...state, naturezaOperacao: payload };
        },
        changeEmpresas(state, { payload }) {
            return { ...state, empresas: payload };
        },

        changeSerie(state, { payload }) {
            return { ...state, serie: payload };
        },

        changeGrupoDespesa(state, { payload }) {
            return { ...state, grupoDespesa: payload };
        },

        changeSGrupoDespesa(state, { payload }) {
            return { ...state, sgrupoDespesa: payload };
        },

        changeContaAPagar(state, { payload }) {
            return { ...state, contaApagar: payload };
        },

        changeContaAPagarExcluidas(state, { payload }) {
            return { ...state, contaApagarExcluidas: payload };
        },

        changeClientesExcluidos(state, { payload }){
            return { ... state, clientesExcluidos: payload}
        },


        // changeCheck da grid produtos
        changeCheckDesc(state, { payload }) {
            return { ...state, checkDesc: payload };
        },
        changeCheckCodBarra(state, { payload }) {
            return { ...state, checkCodBarra: payload };
        },
        changeCheckReferencia(state, { payload }) {
            return { ...state, checkReferencia: payload };
        },
        changeCheckGrupo(state, { payload }) {
            return { ...state, checkGrupo: payload };
        },
        changeCheckSgrupo(state, { payload }) {
            return { ...state, checkSgrupo: payload };
        },
        changeCheckMarca(state, { payload }) {
            return { ...state, checkMarca: payload };
        },
        changeCheckUnid(state, { payload }) {
            return { ...state, checkunid: payload };
        },
        changeCheckPCusto(state, { payload }) {
            return { ...state, checkPCusto: payload };
        },
        changeCheckPVenda(state, { payload }) {
            return { ...state, checkPVenda: payload };
        },
        changeCheckPeso(state, { payload }) {
            return { ...state, checkPeso: payload };
        },
        changeCheckTributacao(state, { payload }) {
            return { ...state, checkgTributacao: payload };
        },
        changeCheckEstoque(state, { payload }) {
            return { ...state, checkEstoque: payload };
        },
        changeCheckEstoqueFisico(state, { payload }) {
            return { ...state, checkEstoqueFisico: payload };
        },
        changeCheckNcm(state, { payload }) {
            return { ...state, checkNcm: payload };
        },
        changeCheckCest(state, { payload }) {
            return { ...state, checkCest: payload };
        },
        changeCheckTipo(state, { payload }) {
            return { ...state, checkTipo: payload };
        },
        changeCheckAtivo(state, { payload }) {
            return { ...state, checkAtivo: payload };
        },
        changeCheckEstoqueMinimo(state, { payload }) {
            return { ...state, checkEstoqueMinimo: payload };
        },
        changeCheckDt_cadastro(state, { payload }) {
            return { ...state, checkDt_cadastro: payload };
        },
        changeCheckOrigem(state, { payload }) {
            return { ...state, checkOrigem: payload };
        },

        // changeCheck da grid clientes
        changeCheckPessoaCli(state, { payload }) {
            return { ...state, checkPessoaCli: payload };
        },
        changeCheckDocCli(state, { payload }) {
            return { ...state, checkDocCli: payload };
        },
        changeCheckRazaoNomeCli(state, { payload }) {
            return { ...state, checkRazaoNomeCli: payload };
        },
        changeCheckFantasiaCli(state, { payload }) {
            return { ...state, checkFantasiaCli: payload };
        },
        changeCheckDt_cadastroCli(state, { payload }) {
            return { ...state, checkDt_cadastroCli: payload };
        },
        changeCheckIeRgCli(state, { payload }) {
            return { ...state, checkIeRgCli: payload };
        },
        changeCheckAtivoCli(state, { payload }) {
            return { ...state, checkAtivoCli: payload };
        },
        changeCheckObsCli(state, { payload }) {
            return { ...state, checkObsCli: payload };
        },
        changeCheckCepCli(state, { payload }) {
            return { ...state, checkCepCli: payload };
        },
        changeCheckEnderecoCli(state, { payload }) {
            return { ...state, checkEnderecoCli: payload };
        },
        changeCheckBairroCli(state, { payload }) {
            return { ...state, checkBairroCli: payload };
        },
        changeCheckNumeroCli(state, { payload }) {
            return { ...state, checkNumeroCli: payload };
        },
        changeCheckComplCli(state, { payload }) {
            return { ...state, checkComplCli: payload };
        },
        changeCheckEstadoCli(state, { payload }) {
            return { ...state, checkEstadoCli: payload };
        },
        changeCheckCidadeCli(state, { payload }) {
            return { ...state, checkCidadeCli: payload };
        },

        // changeCheck da grid forma pagamento
        changeCheckDescPag(state, { payload }) {
            return { ...state, checkDescPag: payload };
        },
        changeCheckAcresPag(state, { payload }) {
            return { ...state, checkAcresPag: payload };
        },
        changeCheckDesconPag(state, { payload }) {
            return { ...state, checkDesconPag: payload };
        },
        changeCheckOrdemPag(state, { payload }) {
            return { ...state, checkOrdemPag: payload };
        },
        changeCheckDt_cadastroPag(state, { payload }) {
            return { ...state, checkDt_cadastroPag: payload };
        },
        changeCheckVlMinPag(state, { payload }) {
            return { ...state, checkVlMinPag: payload };
        },
        changeCheckTipoPag(state, { payload }) {
            return { ...state, checkTipoPag: payload };
        },

        // changeCheck da grid natureza de operação
        changeCheckDescNat(state, { payload }) {
            return { ...state, checkDescNat: payload };
        },
        changeCheckCfop_entradaNat(state, { payload }) {
            return { ...state, checkCfop_entradaNat: payload };
        },
        changeCheckCfop_saidaNat(state, { payload }) {
            return { ...state, checkCfop_saidaNat: payload };
        },
        changeCheckCfop_internoNat(state, { payload }) {
            return { ...state, checkCfop_internoNat: payload };
        },
        changeCheckCfop_externoNat(state, { payload }) {
            return { ...state, checkCfop_externoNat: payload };
        },
        changeCheckCst_dentroNat(state, { payload }) {
            return { ...state, checkCst_dentroNat: payload };
        },
        changeCheckCst_foraNat(state, { payload }) {
            return { ...state, checkCst_foraNat: payload };
        },
        changeCheckDt_cadastroNat(state, { payload }) {
            return { ...state, checkDt_cadastroNat: payload };
        },

        // changeCheck da grid Empresas
        changeCheckRazaoEmp(state, { payload }) {
            return { ...state, checkRazaoEmp: payload };
        },
        changeCheckFantasiaEmp(state, { payload }) {
            return { ...state, checkFantasiaEmp: payload };
        },
        changeCheckRuaEmp(state, { payload }) {
            return { ...state, checkRuaEmp: payload };
        },
        changeCheckBairroEmp(state, { payload }) {
            return { ...state, checkBairroEmp: payload };
        },
        changeCheckNumeroEmp(state, { payload }) {
            return { ...state, checkNumeroEmp: payload };
        },
        changeCheckCepEmp(state, { payload }) {
            return { ...state, checkCepEmp: payload };
        },
        changeCheckComplEmp(state, { payload }) {
            return { ...state, checkComplEmp: payload };
        },
        changeCheckCidadeEmp(state, { payload }) {
            return { ...state, checkCidadeEmp: payload };
        },
        changeCheckCnpjEmp(state, { payload }) {
            return { ...state, checkCnpjEmp: payload };
        },
        changeCheckIeEmp(state, { payload }) {
            return { ...state, checkIeEmp: payload };
        },
        changeCheckCnaeEmp(state, { payload }) {
            return { ...state, checkCnaeEmp: payload };
        },
        changeCheckRegTribEmp(state, { payload }) {
            return { ...state, checkRegTribEmp: payload };
        },
        changeCheckAtivoEmp(state, { payload }) {
            return { ...state, checkAtivoEmp: payload };
        },
        changeCheckUfEmp(state, { payload }) {
            return { ...state, checkUfEmp: payload };
        },
        changeCheckDt_cadastroEmp(state, { payload }) {
            return { ...state, checkDt_cadastroEmp: payload };
        },

        // changeCheck da grid Tributação
        changeCheckDescTrib(state, { payload }) {
            return { ...state, checkDescTrib: payload };
        },
        changeCheckPICMSTrib(state, { payload }) {
            return { ...state, checkPICMSTrib: payload };
        },
        changeCheckPPISTrib(state, { payload }) {
            return { ...state, checkPPISTrib: payload };
        },
        changeCheckPCOFINSTrib(state, { payload }) {
            return { ...state, checkPCOFINSTrib: payload };
        },
        changeCheckCstPisCofinsTrib(state, { payload }) {
            return { ...state, checkCstPisCofinsTrib: payload };
        },
        changeCheckCfopSDentroTrib(state, { payload }) {
            return { ...state, checkCfopSDentroTrib: payload };
        },
        changeCheckCfopSForaTrib(state, { payload }) {
            return { ...state, checkCfopSForaTrib: payload };
        },
        changeCheckCfopEdentroTrib(state, { payload }) {
            return { ...state, checkCfopEdentroTrib: payload };
        },
        changeCheckCfopEforaTrib(state, { payload }) {
            return { ...state, checkCfopEforaTrib: payload };
        },
        changeCheckCstICMSDentroTrib(state, { payload }) {
            return { ...state, checkCstICMSDentroTrib: payload };
        },
        changeCheckCstICMSForaTrib(state, { payload }) {
            return { ...state, checkCstICMSForaTrib: payload };
        },
        changeCheckDt_cadastroTrib(state, { payload }) {
            return { ...state, checkDt_cadastroTrib: payload };
        },

        // changeCheck da grid Transportadora
        changeCheckRazaoTransp(state, { payload }) {
            return { ...state, checkRazaoTransp: payload };
        },
        changeCheckFantTransp(state, { payload }) {
            return { ...state, checkFantTransp: payload };
        },
        changeCheckEndTransp(state, { payload }) {
            return { ...state, checkEndTransp: payload };
        },
        changeCheckBairroTransp(state, { payload }) {
            return { ...state, checkBairroTransp: payload };
        },
        changeCheckNumTransp(state, { payload }) {
            return { ...state, checkNumTransp: payload };
        },
        changeCheckCepTransp(state, { payload }) {
            return { ...state, checkCepTransp: payload };
        },
        changeCheckCidadeTransp(state, { payload }) {
            return { ...state, checkCidadeTransp: payload };
        },
        changeCheckComplTransp(state, { payload }) {
            return { ...state, checkComplTransp: payload };
        },
        changeCheckIeRgTransp(state, { payload }) {
            return { ...state, checkIeRgTransp: payload };
        },
        changeCheckObsTransp(state, { payload }) {
            return { ...state, checkObsTransp: payload };
        },
        changeCheckTipoTransp(state, { payload }) {
            return { ...state, checkTipoTransp: payload };
        },
        changeCheckDocTransp(state, { payload }) {
            return { ...state, checkDocTransp: payload };
        },
        changeCheckAtivoTransp(state, { payload }) {
            return { ...state, checkAtivoTransp: payload };
        },
        changeCheckUfTransp(state, { payload }) {
            return { ...state, checkUfTransp: payload };
        },
        changeCheckDt_cadastroTransp(state, { payload }) {
            return { ...state, checkDt_cadastroTransp: payload };
        },

        // changeCheck da grid Fornecedor
        changeCheckEnderecoForn(state, { payload }) {
            return { ...state, checkEnderecoForn: payload };
        },
        changeCheckBairroForn(state, { payload }) {
            return { ...state, checkBairroForn: payload };
        },
        changeCheckCepForn(state, { payload }) {
            return { ...state, checkCepForn: payload };
        },
        changeCheckDocForn(state, { payload }) {
            return { ...state, checkDocForn: payload };
        },
        changeCheckComplementoForn(state, { payload }) {
            return { ...state, checkComplementoForn: payload };
        },
        changeCheckNomeRazaoForn(state, { payload }) {
            return { ...state, checkNomeRazaoForn: payload };
        },
        changeCheckFantasiaForn(state, { payload }) {
            return { ...state, checkFantasiaForn: payload };
        },
        changeCheckNumeroForn(state, { payload }) {
            return { ...state, checkNumeroForn: payload };
        },
        changeCheckObservacaoForn(state, { payload }) {
            return { ...state, checkObservacaoForn: payload };
        },
        changeCheckTipo_pessoaForn(state, { payload }) {
            return { ...state, checkTipo_pessoaForn: payload };
        },
        changeCheckUfForn(state, { payload }) {
            return { ...state, checkUfForn: payload };
        },
        changeCheckIe_rgForn(state, { payload }) {
            return { ...state, checkIe_rgForn: payload };
        },
        changeCheckCidadeForn(state, { payload }) {
            return { ...state, checkCidadeForn: payload };
        },
        changeCheckAtivoForn(state, { payload }) {
            return { ...state, checkAtivoForn: payload };
        },
        changeCheckDt_cadastroForn(state, { payload }) {
            return { ...state, checkDt_cadastroForn: payload };
        },

    }
})

export const {
    changeUser,
    changeHash,
    changeName,
    changeMarcas,
    changeGrupos,
    changeUnidMedidas,
    changeTributacao,
    changeDark,
    changeProdutos,
    changeFornecedores,
    changeTransportadora,
    changeClientes,
    changeFormaPagam,
    changeSubGrupo,
    changeNaturezaOperacao,
    changeEmpresas,
    changeSerie,
    changeGrupoDespesa,
    changeSGrupoDespesa,
    changeContaAPagar,
    changeContaAPagarExcluidas,
    changeClientesExcluidos,

    // produtos
    changeCheckDesc,
    changeCheckCodBarra,
    changeCheckReferencia,
    changeCheckGrupo,
    changeCheckSgrupo,
    changeCheckMarca,
    changeCheckUnid,
    changeCheckPCusto,
    changeCheckPVenda,
    changeCheckPeso,
    changeCheckTributacao,
    changeCheckEstoque,
    changeCheckEstoqueFisico,
    changeCheckNcm,
    changeCheckCest,
    changeCheckTipo,
    changeCheckAtivo,
    changeCheckEstoqueMinimo,
    changeCheckDt_cadastro,
    changeCheckOrigem,

    // clientes
    changeCheckPessoaCli,
    changeCheckDocCli,
    changeCheckRazaoNomeCli,
    changeCheckFantasiaCli,
    changeCheckDt_cadastroCli,
    changeCheckIeRgCli,
    changeCheckAtivoCli,
    changeCheckObsCli,
    changeCheckCepCli,
    changeCheckEnderecoCli,
    changeCheckBairroCli,
    changeCheckNumeroCli,
    changeCheckComplCli,
    changeCheckCidadeCli,
    changeCheckEstadoCli,

    // forma pagamentos
    changeCheckDescPag,
    changeCheckAcresPag,
    changeCheckDesconPag,
    changeCheckOrdemPag,
    changeCheckDt_cadastroPag,
    changeCheckVlMinPag,
    changeCheckTipoPag,

    // natureza de operação
    changeCheckDescNat,
    changeCheckCfop_entradaNat,
    changeCheckCfop_saidaNat,
    changeCheckCfop_internoNat,
    changeCheckCfop_externoNat,
    changeCheckCst_dentroNat,
    changeCheckCst_foraNat,
    changeCheckDt_cadastroNat,

    //empresas
    changeCheckRazaoEmp,
    changeCheckFantasiaEmp,
    changeCheckRuaEmp,
    changeCheckBairroEmp,
    changeCheckNumeroEmp,
    changeCheckCepEmp,
    changeCheckComplEmp,
    changeCheckCidadeEmp,
    changeCheckCnpjEmp,
    changeCheckIeEmp,
    changeCheckCnaeEmp,
    changeCheckRegTribEmp,
    changeCheckAtivoEmp,
    changeCheckUfEmp,
    changeCheckDt_cadastroEmp,

    // tributação
    changeCheckDescTrib,
    changeCheckPICMSTrib,
    changeCheckPPISTrib,
    changeCheckPCOFINSTrib,
    changeCheckCstPisCofinsTrib,
    changeCheckCfopSDentroTrib,
    changeCheckCfopSForaTrib,
    changeCheckCfopEdentroTrib,
    changeCheckCfopEforaTrib,
    changeCheckCstICMSDentroTrib,
    changeCheckCstICMSForaTrib,
    changeCheckDt_cadastroTrib,

    // transportadora 
    changeCheckRazaoTransp,
    changeCheckFantTransp,
    changeCheckEndTransp,
    changeCheckBairroTransp,
    changeCheckNumTransp,
    changeCheckCepTransp,
    changeCheckCidadeTransp,
    changeCheckComplTransp,
    changeCheckIeRgTransp,
    changeCheckObsTransp,
    changeCheckTipoTransp,
    changeCheckDocTransp,
    changeCheckAtivoTransp,
    changeCheckUfTransp,
    changeCheckDt_cadastroTransp,

    // fornecedor
    changeCheckEnderecoForn,
    changeCheckBairroForn,
    changeCheckCepForn,
    changeCheckDocForn,
    changeCheckComplementoForn,
    changeCheckNomeRazaoForn,
    changeCheckFantasiaForn,
    changeCheckNumeroForn,
    changeCheckObservacaoForn,
    changeCheckTipo_pessoaForn,
    changeCheckUfForn,
    changeCheckIe_rgForn,
    changeCheckCidadeForn,
    changeCheckAtivoForn,
    changeCheckDt_cadastroForn,

} = slice.actions;

export const selectUser = (state: any) => (state.user);
export default slice.reducer;